import BaseComponent from "@js/components/base_component.jsx";

import MuiCampaignsIndexTable from "@js/components/mui/campaigns/index_table.jsx";
import ListSelector from "@js/components/widgets/list_selector.jsx";
import SelectSelector from "@js/components/widgets/select_selector.jsx";

class MuiCampaignsIndex extends BaseComponent {

  render() {
    const table = this.props.campaigns;

    return (
      <div>
        <div className="clearfix text-right">
          <span />

          <div className="">
            <SelectSelector
              optionsGrouped={ this.props.isp_options }
              selectedValue={ this.props.filter_isp_id }
              selectedName={ this.props.filter_isp_name }
              prefix={ "ISP" }
              defaultName={ "All" }
              onChange={ this._onIspFilterChange }
            />
            {
              this.props.sub_accounts &&
                <SelectSelector
                  options={ this.props.sub_accounts }
                  selectedValue={ this.props.filter_sub_account_id }
                  selectedName={ this.props.filter_sub_account_name }
                  prefix={ "Account" }
                  defaultName={ "All Accounts" }
                  onChange={ this._onSubAccountFilterChange }
                />
            }
          </div>

          <EuiDynamicDeliveriesDateFilter
            start={ this.props.filter_date_start }
            end={ this.props.filter_date_end }
            range_type={ this.props.filter_date_range_type }
            onChange={ this._onDateFilterChange }
            show_time_ranges={ false }
            show_last_90_days={ true }
            show_all={ true }
          />

          <EuiDynamicDeliveriesDomainFilter
            label={ I18n.t("monitor.email_sent_from") }
            q_domain={ this.props.filter_domains }
            onChange={ this._onDomainFilterChange }
          />

          {
            this.props.can_view_customer_identifiers &&
              <ListSelector
                label={ I18n.t("headings.ccustid") }
                blankLabel={ I18n.t("monitor.all_ids") }
                icon="id-card"
                query={ this.props.filter_ccustid }
                onChange={ this._onCustomerIdFilterChange }
              />
          }
        </div>

        <Panel heading="campaigns">
          <MuiCampaignsIndexTable
            campaigns={ table.data }
            show_customer_identifiers={ this.props.can_view_customer_identifiers }
            sort_col={ this.props.sort_col }
            sort_dir={ this.props.sort_dir }
            onChangeSort={ this._onChangeSort }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

  _onIspFilterChange(ispId, ispName) {
    this._urlNavigator({
      filter_isp_id: ispId,
    });
  }

  _onSubAccountFilterChange(id, name) {
    this._urlNavigator({
      filter_sub_account_id: id,
    });
  }

  _onCustomerIdFilterChange(query) {
    this._urlNavigator({
      filter_ccustid: query,
    });
  }

  _onDateFilterChange(startDate, endDate, rangeType) {
    this._urlNavigator({
      filter_date_start: startDate,
      filter_date_end: endDate,
      filter_date_range_type: rangeType,
    });
  }

  _onDomainFilterChange(domains) {
    this._urlNavigator({
      filter_domains: domains,
    });
  }

  _onChangeSort(col, dir) {
    this._urlNavigator({
      sort_col: col,
      sort_dir: dir,
    });
  }

  _urlNavigator(opts) {
    Turbolinks.visit(this._urlParams(opts));
  }

  _urlParams(opts) {
    const state = _.extend({}, this.props, opts);

    // Determine the keys we will put in the URL params.
    let keys = [
      "sort_col",
      "sort_dir",
      "filter_isp_id",
      "filter_sub_account_id",
      "filter_ccustid",
      "filter_campaign_id",
      "filter_date_range_type",
      "filter_domains",
    ];
    if ( state.filter_date_range_type === "custom" ) {
      keys.push("filter_date_start");
      keys.push("filter_date_end");
    }

    // Build the params we'll have in the URL.
    let params = {};
    _.each(keys, key => {
      var value = state[key];

      if (!_.isUndefined(value) && !_.isNull(value) && value !== "") {
        params[key] = value;
      }
    });

    // Build the URL params.
    if (_.keys(params).length > 0) {
      return "?" + $.param(params);
    } else {
      return "";
    }
  }

}

export default MuiCampaignsIndex;
